import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=16ba264e&scoped=true"
import script from "./ReadMore.vue?vue&type=script&lang=ts"
export * from "./ReadMore.vue?vue&type=script&lang=ts"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=16ba264e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba264e",
  null
  
)

export default component.exports